<template>
  <div class="container">
    <div style="grid-area: bar1">
      <BarChart :data="deviceInc" title="新增设备数"/>
    </div>
    <div style="grid-area: bar2">
      <BarChart :data="accountInc" title="新增开单"/>
    </div>
    <div style="grid-area: bar3">
      <BarChart :data="incomeInc" title="新增销量"/>
    </div>
    <div style="grid-area: map">
      <Map/>
    </div>
    <div style="grid-area: wallet;position:relative">
      <div style="position: absolute;right: 5px;top:5px;z-index: 1;display: flex;cursor: pointer">
        <div :style="walletButton(0)" @click="walletIndex = 0">过去7天</div>
        <div :style="walletButton(1)" @click="walletIndex = 1">过去30天</div>
      </div>
      <ColumnChart :data="walletInc[walletIndex]"/>
    </div>
  </div>
</template>

<script>
  import BarChart from './component/BarChart'
  import Map from './component/Map'
  import axios from 'axios'
  import ColumnChart from './component/ColumnChart'
  import { randomIntegerInRange } from '../../utils/tools'
  export default {
    name: 'index.js',
    components: { ColumnChart, Map, BarChart },
    data() {
      return {
        deviceInc: [0, 0, 0],
        accountInc: [0, 0, 0],
        incomeInc: [0, 0, 0],
        walletInc: [[], []],
        walletIndex: 0
      }
    },
    beforeCreate() {
      console.log(this.$parent.$el.style)
      this.$parent.$el.style.backgroundColor = '#F2F2F2'
    },
    beforeDestroy() {
      this.$parent.$el.style.backgroundColor = ''
    },
    created() {
      this.batchQueryBarData('/srsScreen/income.do', [0, 7, 30], 'incomeInc')
      this.batchQueryBarData('/srsScreen/deviceAccount.do', [0, 7, 30], 'accountInc')
      this.batchQueryBarData('/srsScreen/deviceIncrease.do', [0, 7, 30], 'deviceInc')
      this.batchQueryBarData('/srsScreen/wallet.do', [7, 30], 'walletInc')
      axios
        .get('/srsScreen/deviceDistribution.do')
        .then(({data}) => {

        })
    },
    methods: {
      batchQueryBarData(url, days, target) {
        days.forEach(async (day, index) => {
          let {data} = await axios.get(`${url}?day=${day}`)
          this.$set(this[target], index, data.data)
        })
      },
      walletButton(index) {
        const backgroundColor = this.walletIndex === index ? '#FC6853' : '#EDEDED'
        const color = this.walletIndex === index ? '#FFFFFF' : '#212121'
        return {
          borderRadius: '14.14px',
          backgroundColor,
          color,
          padding: '5px 9px',
          fontSize: '13px',
          textAlign: 'center',
          marginLeft: index === 1 ? '5px' : '0'
        }
      }
    }

  }
</script>

<style scoped>
  .container {
    height: 100%;
    width: 100%;
    background-color: #F2F2F2;
    display: grid;
    grid-template-areas:
            'bar1 bar1 bar2 bar2 bar3 bar3'
            'map map map wallet wallet wallet';
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    grid-template-rows: 26% 1fr;
    grid-column-gap: 15px;
    grid-row-gap: 15px;
  }

</style>